import { isNil } from "lodash";
import { useSearchParams } from "react-router-dom";
import ProtectedRoute from "../../../../components/protected-route/protected-route";
import { hasElements } from "../../../../core/utils";
import useOnce from "../../../../hooks/use-once";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import useStorage from "../../../../hooks/use-storage";
import { PagoPendienteRespuesta, ResumenOperacion } from "../types/pagos.types";

const PagosECheckPage = () => {
	const { pop } = useStorage<PagoPendienteRespuesta[]>();
	const { push } = useStorage<ResumenOperacion>();
	const [searchParams] = useSearchParams();
	const navigate = usePathNavigate();

	useOnce(() => {
		const pagos = pop("pagosEnviados");
		const token = searchParams.get("token")?.replaceAll(" ", "+");

		if (isNil(token) || !hasElements(pagos)) {
			navigate("/:segmento/Pagos");
			return;
		}

		push("resumenOperacion", { formaPago: 4, datos: { token } });

		if (pagos.length === 1) {
			navigate("/:segmento/pagos/individual", { state: pagos });
		} else {
			navigate("/:segmento/pagos/multiples", { state: pagos });
		}
	});

	return (
		<ProtectedRoute>
			<h3>Procesando respuesta</h3>
		</ProtectedRoute>
	);
};

export default PagosECheckPage;